const getters = {
    // schoolName: state => state.app.schoolName,
    currentPath: state => state.app.currentPath,
    homeWorkReportPath: state => state.app.homeWorkReportPath,
    interactPath: state => state.app.interactPath,
    interactPBPath: state => state.app.interactPBPath,
    topHeaderName: state => state.app.topHeaderName,
    freeLoginOrigin: state => state.app.freeLoginOrigin,
    user: state => state.user.user,
    token: state => state.user.token,
    name: state => state.user.name,
    userId: state => state.user.userId,
    userName: state => state.user.userName,
    schoolId: state => state.user.schoolId,
    schoolName: state => state.user.schoolName,
    schoolType: state => state.user.schoolType,
    status: state => state.user.status,
    adminType: state => state.user.adminType,
    userType: state => state.user.userType,
    userLoginType: state => state.user.userLoginType,
    userHeadImg: state => state.user.userHeadImg,
    agentId: state => state.user.agentId,
    agentName: state => state.user.agentName,
    logoPathPre: state => state.app.logoPathPre,
    roleIds: state => state.user.roleIds,
    phase: state => state.user.phase
}
export default getters;
